import { Pill } from './shared';

function Tile({ label, value, testId, tone = '' }) {
  return (
    <div className="border border-slate-200 bg-white p-3" data-testid={testId}>
      <div className="text-[10px] uppercase font-bold text-slate-500">{label}</div>
      <div className={`text-sm font-mono mt-1 ${tone}`}>{value}</div>
    </div>
  );
}

function Counts({ title, data, testId }) {
  const entries = Object.entries(data || {});
  return (
    <div className="border border-slate-200 bg-white p-4" data-testid={testId}>
      <div className="text-xs font-bold uppercase tracking-wider text-slate-500">{title}</div>
      {entries.length === 0
        ? <div className="mt-2 text-sm text-slate-400">Sin documentos</div>
        : <div className="mt-2 flex flex-wrap gap-2">
            {entries.map(([k, v]) => (
              <span key={k} className="inline-flex items-center gap-1.5">
                <Pill value={k} /> <span className="font-mono text-sm">{v}</span>
              </span>
            ))}
          </div>}
    </div>
  );
}

export function DianSummary({ health }) {
  if (!health) return null;
  const f = health.factus || {};
  const last = health.last_close_run;
  return (
    <div className="space-y-4" data-testid="dian-summary">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <Tile testId="dian-env" label="Ambiente Factus" value={f.env} />
        <Tile testId="dian-flag" label="Emisión real" value={f.enabled ? 'ACTIVADA' : 'DESACTIVADA'}
          tone={f.enabled ? 'text-rose-700' : 'text-emerald-700'} />
        <Tile testId="dian-creds" label="Credenciales env activo" value={f.credentials_present ? 'Presentes' : 'Faltan'} />
        <Tile testId="dian-cron-secret" label="Secreto cierre programado" value={health.cron_secret_configured ? 'Configurado' : 'Falta'} />
        <Tile testId="dian-last-close" label="Último cierre"
          value={last ? `${last.period} · ${last.mode} · ${last.status}` : 'Ninguno'} />
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        <Counts testId="dian-invoice-counts" title="Facturas" data={health.invoices} />
        <Counts testId="dian-cn-counts" title="Notas crédito" data={health.credit_notes} />
        <Counts testId="dian-event-counts" title="Eventos facturables" data={health.events} />
      </div>
    </div>
  );
}
